<template>
  <div>
    <div class="d-flex justify-end align-center ma-6">
      <v-btn v-if="$vuetify.breakpoint.mdAndUp" outlined color="success" @click="exportExcel">
        <v-icon left>mdi-file-excel</v-icon> Xuất Excel
      </v-btn>
      <v-btn
        v-if="$auth.policies['add-new-attendance']"
        class="ml-6"
        @click="checkinState = !checkinState"
        dark
        color="#0D47A1"
      >
        <v-icon left>add</v-icon>Thêm điểm danh
      </v-btn>
    </div>
    <v-card outlined class="pa-6 mx-6 mb-6 elevation-0">
      <AttendanceFilter ref="attendance-filter" @onFilterChanged="refresh" />
    </v-card>
    <v-card outlined class="mx-6 mb-6 elevation-0">
      <AttendanceDataTable ref="table" />
    </v-card>
    <AddAttendanceDialog :state="checkinState" @attendanceAdded="refresh(searchParams)" />
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'
import { Attendance } from '@/plugins/api'
import { isEmpty, get } from 'lodash'
import moment from 'moment'
import utils from '@/plugins/utils'
import AttendanceFilter from './components/AttendanceFilter'
import AttendanceDataTable from './components/AttendanceDataTable'
import AddAttendanceDialog from './components/AddAttendanceDialog'

export default {
  data() {
    return {
      checkinState: false,
      menu: false,
      date: moment().format('YYYY-MM-DD')
    }
  },
  components: {
    AttendanceFilter,
    AttendanceDataTable,
    AddAttendanceDialog
  },
  computed: {
    ...mapState('attendance', ['searchParams', 'attendanceStudentSearchParams'])
  },
  mounted() {
    this.$refs['attendance-filter'].onFilterChanged()
  },
  methods: {
    ...mapActions('attendance', ['getAttendanceStudents', 'getManyAttendances']),
    refresh(query) {
      this.$refs.table.searchAttendances(query)
    },
    async exportExcel() {
      this.$loading.active = true
      try {
        let headers = [...this.$refs.table.$data.headers]
        headers.splice(1, 0, {
          text: 'Mã số',
          value: 'code'
        })
        let excelHeader = headers.map(({ text, value }) => ({ text, value }))
        excelHeader = excelHeader.filter(excel => excel.value !== 'dob' && excel.value !== 'action')
        const filters = this.$options.filters

        const defaultQuery = {
          time_gte: moment()
            .startOf('day')
            .toISOString(),
          time_lte: moment()
            .endOf('day')
            .toISOString()
        }
        const params = !isEmpty(this.attendanceStudentSearchParams) ? this.attendanceStudentSearchParams : defaultQuery
        // teacher
        delete params['_start']
        delete params['_limit']
        params['_sort'] = 'studentNameToNumber:ASC'
        const studentCheckins = await Attendance.fetch({ ...params, _limit: -1 })
        const attendances = JSON.parse(JSON.stringify(studentCheckins))
        const data = attendances.map(item => {
          item.code = filters.getStudentCode(item.student.code)
          item.class = get(item, 'class.title')
          item.student = get(item, 'student.name')

          let timeList = ['--', '--']
          let status = filters.getAttendanceStatus(item.status)
          if (item.checkins) {
            const timeCheckIn = get(item.checkins, '0.checkIn')
            const timeCheckOut = get(item.checkins, '0.checkOut')
            if (timeCheckIn) {
              timeList[0] = filters.hhmm(timeCheckIn)
            }
            if (timeCheckOut) {
              timeList[1] = filters.hhmm(timeCheckOut)
            }
          }
          item.time = timeList.join(' / ')
          item.status = status

          return item
        })
        utils.exportExcel(data, excelHeader, `DanhSachDiemDanh-${moment(params.time).format('DD/MM')}`)
      } catch (error) {
        this.$alert.error('Đã có lỗi xảy ra: ' + error)
      } finally {
        this.$loading.active = false
      }
    }
  }
}
</script>

<style></style>
